// removed by extract-text-webpack-plugin
module.exports = {"day":"src-components-Schedule-Header-__weekday__day--3BxWy","activeDay":"src-components-Schedule-Header-__weekday__activeDay--X6DgA src-components-Schedule-Header-__weekday__day--3BxWy","weekdayContent":"src-components-Schedule-Header-__weekday__weekdayContent--28ngg","dayName":"src-components-Schedule-Header-__weekday__dayName--3iQ9w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Schedule/Header/weekday.css
// module id = 1992
// module chunks = 0